export const repeatOptions = () => {
    return [
        {value: "once", label: "Once"},
        {value: "daily", label: "Daily"},
        {value: "weekly", label: "Weekly"}
    ];
}

export const durationOptions = () => {
    return [
        {label: "15 Mins", value: 15 * 60},
        {label: "30 Mins", value: 30 * 60},
        {label: "45 Mins", value: 45 * 60},
        {label: "1 Hour", value: 60 * 60},
        {label: "90 Mins", value: 90 * 60},
        {label: "2 Hours", value: 120 * 60},
    ]
}
